export const TeamliveRequestsEmployerRoutes = [
    {
        "url": "/sickness-requests?request_id&brand_id&user_id&active_tab&start_date&end_date",
        "name": "appLayout.schedule.sickness-requests",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            request_id: { dynamic: true },
            brand_id: { dynamic: true },
            user_id: { dynamic: true },
            active_tab: { dynamic: true },
            start_date: { dynamic: true },
            end_date: { dynamic: true }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                "component": "teamliveRequestEmployer"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["teamlive-requests"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/teamlive-requests/teamlive-requests.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/absence-requests?request_id&brand_id&user_id&active_tab&start_date&end_date",
        "name": "appLayout.schedule.absence-requests",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            request_id: { dynamic: true },
            brand_id: { dynamic: true },
            user_id: { dynamic: true },
            active_tab: { dynamic: true },
            start_date: { dynamic: true },
            end_date: { dynamic: true }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                "component": "teamliveRequestEmployer"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["teamlive-requests"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/teamlive-requests/teamlive-requests.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=teamlive-requests-employer.routes.js.map